export default class ClickMatchFamilyEvent {
    export() {
        return {
            code_fam_match: this.codeFamMatch,
        };
    }
}
